import React from "react";

import Layout from "../../../components/v2/Layout";
import OnlineServices from "../../../components/v2/Home/OnlineServices";
import Slideshow from "../../../components/v2/Home/Slideshow";
import { Cookie } from "../../../components/LandingPage/Cookie";
import NoticeModal from "../../../components/v2/NoticeModal";

export default function Home() {
  return (
    <Layout>
      <NoticeModal />
      <Slideshow />
      <OnlineServices />
      <Cookie />
    </Layout>
  );
}
